import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-bar-top',
  templateUrl: './nav-bar-top.component.html',
  styleUrls: ['./nav-bar-top.component.scss']
})
export class NavBarTopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
